import React, { forwardRef } from 'react'

type Props = {
    src: string
    alt?: string
    width?: number | string
    height?: number | string
    fill?: boolean
    quality?: number
    priority?: boolean
    placeholder?: 'blur' | 'empty'
    blurDataURL?: string
    layout?: string
    objectFit?: string
    objectPosition?: string
    loader?: any
    unoptimized?: boolean
    onLoadingComplete?: any
    lazyBoundary?: string
    lazyRoot?: any
    ref?: React.Ref<HTMLImageElement>
    [key: string]: any
}

const Image = forwardRef<HTMLImageElement, Props>(({
    src, alt, fill,
    layout,
    objectFit, objectPosition,
    width, height,
    // consumed but unused — present only to avoid them landing on <img>
    placeholder: _ph, blurDataURL: _bd, quality: _q, priority,
    loader: _lo, unoptimized: _un, onLoadingComplete: _olc, lazyBoundary: _lb, lazyRoot: _lr,
    style, ...props
}, ref) => {
    const isFill = fill || layout === 'fill'

    const computedStyle: React.CSSProperties = {
        ...(isFill ? { position: 'absolute', inset: 0, width: '100%', height: '100%' } : {}),
        ...(objectFit ? { objectFit: objectFit as React.CSSProperties['objectFit'] } : {}),
        ...(objectPosition ? { objectPosition } : {}),
        ...style,
    }

    return (
        <img
            ref={ref}
            src={src}
            alt={alt}
            style={computedStyle}
            width={!isFill ? width : undefined}
            height={!isFill ? height : undefined}
            loading={priority ? 'eager' : 'lazy'}
            {...props}
        />
    )
})

Image.displayName = 'Image'

export default Image
